module.exports = __webpack_public_path__ + "img/tosano.56351d7f.svg";